var React = require('react');

function Dashboard (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M10.5 4.5H4.5V10.5H10.5V4.5Z","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M19.5 4.5H13.5V10.5H19.5V4.5Z","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M10.5 13.5H4.5V19.5H10.5V13.5Z","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":2}),React.createElement("path",{"d":"M19.5 13.5H13.5V19.5H19.5V13.5Z","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":3})]);
}

Dashboard.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 24 24","fill":"none"};

module.exports = Dashboard;

Dashboard.default = Dashboard;
